import { useIntl } from 'react-intl'
import { useRecoilCallback, useRecoilValue } from 'recoil'

import {
  Chip,
  ChipIconTimes,
  ChipIconWrapper,
  Flex,
  FlexItem,
  NoResults,
  Text,
  TEXT_VARIANT_BOLD
} from 'mailup-web-components'

import { resetSearchCallback } from 'Pages/WorkflowStatistics/recoil/callbacks/callbacks'
import {
  noResultsState,
  resultsState
} from 'Pages/WorkflowStatistics/recoil/state/search'
import {
  fromUTCtoZoneFormatted,
  getLang,
  STORE_KEY_LIST,
  storeGet
} from 'mailup-react-helpers'

const Results = () => {
  const intl = useIntl()
  const { TimeZoneCode } = storeGet(STORE_KEY_LIST)
  const lang = getLang()

  const noResults = useRecoilValue(noResultsState)
  const { recipientContact, subscribedOn } = useRecoilValue(resultsState)
  const resetSearch = useRecoilCallback(resetSearchCallback, [])

  if (noResults) {
    return (
      <>
        <NoResults
          text={intl.formatMessage({
            id: 'Load.AutomationWorkflowTroubleshooting.NoSearchResultTitle'
          })}
        />
      </>
    )
  }

  const chipLabel = `${recipientContact} ( ${intl.formatMessage({
    id: 'Load.AutomationWorkflowTroubleshooting.Suscripted'
  })}  ${fromUTCtoZoneFormatted(
    subscribedOn,
    TimeZoneCode,
    'YYYY-MM-DD ddd HH:mm [UTC]Z',
    lang
  )} ) `

  return (
    <Flex alignItems='center'>
      <FlexItem>
        <Text variant={TEXT_VARIANT_BOLD}>
          {intl.formatMessage({
            id: 'Load.AutomationWorkflowTroubleshooting.FilterBy'
          })}
        </Text>
      </FlexItem>
      <FlexItem margin='0 0 0 8px'>
        <Chip
          data-mu-test='workflow-statistics__chip-recipient'
          label={chipLabel}
        >
          <ChipIconWrapper onClick={resetSearch}>
            <ChipIconTimes />
          </ChipIconWrapper>
        </Chip>
      </FlexItem>
    </Flex>
  )
}

export default Results
